
// export const baseUrl="http://nbxlhspt.yunqizhongguo.com"
// export const uploadUrl="http://nbxlhspt.yunqizhongguo.com/api/common/upload"
export const baseUrl="https://xlink-material.cn"
export const uploadUrl="https://xlink-material.cn/api/common/upload"


